import script from "./PreAutorizationsFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PreAutorizationsFormPage.vue?vue&type=script&setup=true&lang=js"

import "./PreAutorizationsFormPage.vue?vue&type=style&index=0&id=699c8154&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-699c8154"]])

export default __exports__